import { waPricingPlanInterface } from "../models/waPricingPlan.interface";

const initialState: waPricingPlanInterface = {
    showSideModal: false,
    showSuccessMessage: false,
    showOrderSummary: false,
    paymentSuccessMessage: false,
    waPricingPlan: {
        status: 'Cancelled', // Unpublished, Inactive, Active, Grace Period, Cancelled
        setup_fee: 0,
        package_cost: 0,
        pending_amount: 0,
        free_sessions: 0,
        next_payment_date: '',
        cancelled_date: '',
    },
    next_payment_date: '',
    countryFees: [],
}

export const waPricingPlanReducer = (state: waPricingPlanInterface = initialState, action: any) => {
    switch (action.type) {
        case 'SHOW_WA_PRICING_PLAN_SIDE_MODAL':
            return {
                ...state,
                showSideModal: true,
            };
        case 'HIDE_WA_PRICING_PLAN_SIDE_MODAL':
            return {
                ...state,
                showSideModal: false,
                showSuccessMessage: false,
            };
        case 'SHOW_WA_PRICING_PLAN_SUCCESS_MESSAGE':
            return {
                ...state,
                showSuccessMessage: true,
            };
        case 'SHOW_ORDER_SUMMARY':
            return {
                ...state,
                showOrderSummary: true,
            };
        case 'HIDE_ORDER_SUMMARY':
            return {
                ...state,
                showOrderSummary: false,
            };
        case 'SHOW_PAYMENT_SUCCESS_MESSAGE':
            return {
                ...state,
                paymentSuccessMessage: true,
            };
        case 'HIDE_PAYMENT_SUCCESS_MESSAGE':
            return {
                ...state,
                paymentSuccessMessage: false,
            };
        case 'SET_WA_PRICING_PLAN_DATA':
            return {
                ...state,
                waPricingPlan: action.payload.wa_pricing_plan,
                countryFees: action.payload.country_fees,
            };
        case 'SET_NEXT_PAYMENT_DATA':
            return {
                ...state,
                next_payment_date: action.payload.next_payment_date,
            };
        default:
            return state;
    }
}